import { useState, useEffect } from "react";
import FormData from "form-data";
import * as ReactBootStrap from "react-bootstrap";
import axios from "axios";


function Passport() {
  const [cardData, setCardData] = useState({
    Document_Type: "",
    Status:"",
    Country: "",
    Surname: "",
    Name: "",
    Doc_Number: "",
    Nationality: "",
    DOB: "",
    Gender: "",
    Expiry_Date: "",
    Father_Name: "",
    Mother_Name: "",
    Address: "",
    
 
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)

  useEffect(() => { 
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_Type: "",
      Country: "",
      Surname: "",
      Name: "",
      Doc_Number: "",
      Nationality: "",
      DOB: "",
      Gender: "",
      Expiry_Date: "",
      Father_Name: "",
      Mother_Name: "",
      Address: "",
      
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://pualpnvmpi.execute-api.ap-south-1.amazonaws.com/default/PassportOcrService",
      headers: {
        "x-api-key": "mOlfewCV7q5ASQs8wDOKP9krwUYYij4U7wrwILlS",
        authorizationToken: "M3AU3OPdGk1Wo6xw",
      },
      data: data,
    };

    axios(config)
   
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
        
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
          <h2 class="pageTitle">Passport OCR</h2>
          <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
          <br />
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Document Type</th>
                <td>{cardData.Document_Type}</td>
              </tr>
              <tr>
                <th width="25%">Status</th>
                <td>{cardData.Status}</td>
              </tr>
              <tr>
                <th>Document Number</th>
                <td>{cardData.Doc_Number}</td>
              </tr>
              <tr>
                <th>Country</th>
                <td>{cardData.Country} </td>
              </tr>
              <tr>
                <th>Surname</th>
                <td>{cardData.Surname}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{cardData.Name}</td>
              </tr>
            
              <tr>
                <th>Nationality</th>
                <td>{cardData.Nationality}</td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td>{cardData.DOB}</td>
              </tr>
              <tr>
                <th>Gender</th>
                <td>{cardData.Gender}</td>
              </tr>
              <tr>
                <th>Expiry Date</th>
                <td>{cardData.Expiry_Date}</td>
              </tr>
              <tr>
                <th>Father Name</th>
                <td>{cardData.Father_Name}</td>
              </tr>
              <tr>
                <th>Mother Name</th>
                <td>{cardData.Mother_Name}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{cardData.Address} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Passport;
